export const POST = "post";
export const POST_TYPE = "postType";
export const CAROUSEL = "carousel";
